/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is 30 minutes of cardio enough exercise?`)
};

const es_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Son 30 minutos de cardio suficiente ejercicio?`)
};

const de_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind 30 Minuten Cardio genug Bewegung?`)
};

const nl_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is 30 minuten cardio genoeg beweging?`)
};

const fr_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minutes de cardio suffisent-elles comme exercice ?`)
};

const it_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minuti di cardio sono un esercizio sufficiente?`)
};

const pt_br2_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minutos de cardio são exercício suficiente?`)
};

const pt_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 minutos de cardio são exercício suficiente?`)
};

const ja_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30分の有酸素運動は十分な運動量ですか？`)
};

const zh_timer_u30m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30分钟有氧运动的锻炼量足够吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u30m_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u30m_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u30m_faq3_q", locale)
	if (locale === "en") return en_timer_u30m_faq3_q(inputs)
	if (locale === "es") return es_timer_u30m_faq3_q(inputs)
	if (locale === "de") return de_timer_u30m_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u30m_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u30m_faq3_q(inputs)
	if (locale === "it") return it_timer_u30m_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u30m_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u30m_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u30m_faq3_q(inputs)
	return zh_timer_u30m_faq3_q(inputs)
};